var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterprisePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-06"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.75 13.75H7.75C6.34987 13.75 5.6498 13.75 5.11502 14.0225C4.64462 14.2622 4.26217 14.6446 4.02248 15.115C3.75 15.6498 3.75 16.3499 3.75 17.75V26.25M26.25 26.25V7.75C26.25 6.34987 26.25 5.6498 25.9775 5.11502C25.7378 4.64462 25.3554 4.26217 24.885 4.02248C24.3502 3.75 23.6501 3.75 22.25 3.75H17.75C16.3499 3.75 15.6498 3.75 15.115 4.02248C14.6446 4.26217 14.2622 4.64462 14.0225 5.11502C13.75 5.6498 13.75 6.34987 13.75 7.75V26.25M27.5 26.25H2.5M18.125 8.75H21.875M18.125 13.75H21.875M18.125 18.75H21.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlan);
export default __webpack_public_path__ + "static/media/enterprise-plan.7c5eb0bcc66bde2a91f98672f8f26d62.svg";
export { ForwardRef as ReactComponent };